import { useMutation, queryCache } from 'react-query'
import axios from 'axios'
import cogoToast from 'cogo-toast'

const deleteIntestatarioById = async (intestatarioId: number) => {
  const { data } = await axios.delete(`/intestatari/${intestatarioId}/`)
  return data
}

const useDeleteIntestatarioById = () => {
  return useMutation(
    (intestatarioId: number) => {
      return deleteIntestatarioById(intestatarioId)
    },
    {
      onSuccess: (res: any) => {
        queryCache.refetchQueries('alunnoByIdByAnno')
        cogoToast.success('Intestatario eliminato')
      },
      onError: () => {},
    }
  )
}

export default useDeleteIntestatarioById
